import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
    transform(value: string, limit: number): string {
        if (value.length <= limit) {
            return value;
        } else {
            return value.substring(0, limit - 3) + '...';
        }
    }
}
